import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {isEnhancedPrivateCard} from '../../../helpers/models/cardHelpers';
import {CardModel} from '../../../models/api/cardModel';

/*
 * Constants.
 */

const tooltipMaxWidth = 240; // px.

/*
 * Props.
 */

interface ContactCardHeaderPrivateCardIndicatorProps {
  card?: CardModel;
}

/*
 * Style.
 */

const StyledIconWrapperDiv = styled.div`
  display: flex;
  flex-flow: column-reverse;
  align-items: flex-end;
  flex: 0 0 27px;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  height: 21px;
  padding-top: 1px;
`;

const StyledTooltipContactSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const ContactCardHeaderPrivateCardIndicator: FC<ContactCardHeaderPrivateCardIndicatorProps> = (
  props,
) => {
  const {card} = props;

  if (!card || !isEnhancedPrivateCard(card)) {
    return null;
  }

  return (
    <StyledIconWrapperDiv>
      <TooltipCoordinator render={renderPrivateContactTooltip} placement="top" maxWidth={tooltipMaxWidth}>
        <StyledIcon name="lockSmall" />
      </TooltipCoordinator>
    </StyledIconWrapperDiv>
  );
};

/*
 * Helpers.
 */

function renderPrivateContactTooltip() {
  return (
    <>
      <StyledTooltipContactSpan>
        <Trans id="contact-card-header-private-contact-tooltip-1">Private contact</Trans>
      </StyledTooltipContactSpan>
      {' · '}
      <Trans id="contact-card-header-private-contact-tooltip-2">
        Only you can view this contact’s details.
      </Trans>
    </>
  );
}
